import { Component, OnInit, ViewChild, TemplateRef } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { benchmarkkpi, tranbenchmarkkpi, tranbenchmarkkpihistory, benchmarkkpientry, year, importtranbenchmarkkpi, filecontent } from './../../../models/slakpi';
import { division, user, department, targetMaster, performancemaster, geographicArea } from './../../../models/admin';
import { UtilityService } from './../../../services/utility.service';
import { BMApiService } from './../../../services/bm.service';
import { SpinnerVisibilityService } from 'ng-http-loader';
import Swal from 'sweetalert2'
import { UserService } from './../../../services/user.service';
import { Router, Params, ActivatedRoute } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { uniqBy } from 'lodash';

import {
  AngularGridInstance,
  Column,
  FieldType,
  Filters,
  Formatter,
  GridOption,
  FileType,
  Formatters,
  MenuCallbackArgs,

} from 'angular-slickgrid';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { AdminApiService } from '../../../services/admin.service';
import { ToasterService } from '../../../toaster.service';
import { SLAKPIApiService } from '../../../services/slakpi.service';

import * as XLSX from 'xlsx';
@Component({
  selector: 'app-bench-mark-kpi',
  templateUrl: './bench-mark-kpi.component.html',
  styleUrls: ['./bench-mark-kpi.component.css']
})
export class BenchMarkKPIComponent implements OnInit {
  public gridApi: any;
  public gridColumnApi: any;
  public columnDefs: any;
  public defaultColDef: any;
  public rowData: any;
  public PopoverModule;
  modalRef: BsModalRef;
  modalRefEntry: BsModalRef;
  importRef: BsModalRef;
  @ViewChild('addtemplate', { static: false }) addtemplate: TemplateRef<any>;
  @ViewChild('entrytemplate', { static: false }) entrytemplate: TemplateRef<any>;
  @ViewChild('importtemplate', { static: false }) importtemplate: TemplateRef<any>;
  columnDefinitions: Column[];
  gridOptions: GridOption;
  dataset: any;
  public selTab = true;
  public data: any;
  public gridload: number = 0;
  public division_data: any;
  public department_data: any;
  public kpiTypeUno_data: any;
  public target_data: any;
  public StrategicObjective_data: any;
  public StrategicPriority_data: any;
  public trend_data: any;
  public reportVehicle_data: any;
  public condition2_data: any;
  public slaStatusRule_data: any;
  public dataEntry_data: any;
  public user_data: any;
  public dataEntry_data_filter: any;
  public user_data_filter: any;

  public strategicObjective_data_filter: any;
  public strategicPriority_data_filter: any;
  public frequency_data: any;
  public selected_kpiCode: string = '';
  public editSettings: Object;
  public filterSettings: Object;
  public toolbar: string[];
  public pageSettings: Object;
  public formatoptions: Object;
  public orderData: object;
  public kpiData: object[];
  public kpiForm: FormGroup;
  submitted: boolean = false;
  benmarksubmitted: boolean = false;
  invalid: boolean = false;
  public loading: boolean = true;
  public pageAction: string = 'add';
  isShow = false;
  isBenchMarkable: boolean = false;
  isAddentry: boolean = false;
  public value_inpdataEntryUno: number[];
  public value_level1ApproverUno: number[];
  public value_level2ApproverUno: number[];
  public value_level3ApproverUno: number[];

  public permission: number = 1;
  public divisionUno_filter: number = 0;
  public checkbox_filter: boolean = false;
  //for Users Permission
  public permision_add: boolean = false;
  public permision_edit: boolean = false;
  public permision_delete: boolean = false;
  objBenchmarkKPI: any = new benchmarkkpi();
  objTranBenchmarkKPI: any = new tranbenchmarkkpi();
  selectedEditItem: any = new tranbenchmarkkpi();
  user: any = {};
  login_UserID: string; // number
  isAdmin: boolean = false;
  angularGrid: AngularGridInstance;
  //For Filter

  public sli_data: any;

  public slaUnofilter?: number = 0;
  public divisionUnofilter?: number = 0;
  public divisionUnoSecondaryfilter?: number = 0;
  public frequencyUnofilter?: number = 0;
  public isStart: boolean = true;
  public isToggle: boolean = true;

  public selectedfrequencyUno: number;

  public uniqueData: any;
  public masterData: any;
  public filterOption: any;


  public benchMarkYear_data: any;
  public source_data: any;
  public peer_data: any;
  public consideration_data: any;
  public selectedItemID: any;
  public selectedItemBenchmarkable: boolean = false;
  public isTranData: boolean = false;

  public tranBenchMarkKPIHistory_data: any;

  public multipleBemchMarkEntry = [];
  public benchmarkbtn: string = 'Add';

  public benchmarkYear: string = '';
  public benchmarks: string = '';
  public sourceUno: string = '';
  public peerUno: string = '';
  public considerationUno: string = '';
  public filter: string = '';
  public targetValue: string = '';
  public actualValue: any;
  public isSubmitted: boolean = false;
  public selectedEditItemIndex: number;

  public isBMChampion: boolean = false;
  public isBMTeam: boolean = false;
  public isBMVisitor: boolean = false;
  public isBMAdmin: boolean = false;

  searchText: string;
  dataSearch: any;
  noDataImg: any;
  tenantUno: any;
  currentYear: number;
  yearData: any;
  selectedKPI: any;
  isDuplicateMsg: boolean = false;
  benchMarkEntryExportList: any = [];
  isReportingVehicle: boolean = false;
  geographicAreaList: any = [];
  currentlyChecked: any;
  todayDate = new Date();
  year1Label: any = '';
  year2Label: any = '';
  year3Label: any = '';
  year1Value: any = '';
  year2Value: any = '';
  year3Value: any = '';
    selectedAreaItems: any=[];
  editSelectedAreaItems: any = [];

  uploadedFiles: any;
  arrayData: any;
  dataArray: any[] = [];
  array1: any;
  BMUno: any;
  data1: any = [];
    trendName: string;
    datas: string;
    peer: any;
    source: any;
    Considered_benchmarks: any;
  importDataList: any = [];
  importDataList_old: any = [];
    benchMarkList: any=[];
  searchBecnhmarkListText: any;
  public id: number;
  public deleteId: number;
    isSearchTxtBox: boolean=true;
    isBenchmarkloading: boolean=true;
  constructor(private formBuilder: FormBuilder, private toaster: ToasterService, public restapiBM: BMApiService, public restAdminApi: AdminApiService, public utilityService: UtilityService, private router: Router, private spinner: SpinnerVisibilityService, private userService: UserService, private modalService: BsModalService, public restSLAKPIApi: SLAKPIApiService, public _activatedRoute: ActivatedRoute) {
    this.user = this.userService.getUserInfo();
    this.login_UserID = this.user.id;
    this.ValidateUserAccess();
    this.noDataImg = this.utilityService.getnodataImage();
    this.tenantUno = this.user.tenantUno;
    this.currentYear = Number(this.user.currentYear);

    this._activatedRoute.queryParams.subscribe((params: Params) => {
      

      if (params['divisionuno'] != null) {
        this.divisionUnofilter = Number(params['divisionuno']);

      }
    });
  }
  //Method used To Validate User Permission

  ValidateUserAccess() {
    

    this.isAdmin = (this.user.role == 'Administrator' || this.user.role == 'BM Administrator') ? true : false;

    if (this.user.role == 'BM Champions')
      this.isBMChampion = true;
    if (this.user.role == 'BM Team')
      this.isBMTeam = true;
    if (this.user.role == 'BM Visitor')
      this.isBMVisitor = true;
    if (this.user.role == 'BM Administrator') { this.isBMAdmin = true; }

    if (!this.isAdmin) {
      let userPermissionData = this.userService.getUserRights("Benchmarking Metadata");
      if (userPermissionData != null && userPermissionData != undefined && userPermissionData.length > 0) {
        if (userPermissionData[0].showPage == 1) {

        }
        else {
          this.router.navigateByUrl('/access-denied');
        }
      }
    }

  }

  ngOnInit() {

    this.userService.CheckLogin();
    let year = this.todayDate.getFullYear();
    this.year1Label = year - 1;
    this.year2Label = year - 2;
    this.year3Label = year - 3;
    this.gridOptions = {
      autoHeight: true,
      enableAutoResize: true,
      enablePagination: true,
      pagination: {
        pageSizes: [5, 10, 20, 50, 100, 500],
        pageSize: 20
      },
      enableFiltering: true,
      alwaysShowVerticalScroll: false,
      enableRowSelection: true,
      autoResize: {
        containerId: 'musherat-grid',
        delay: 0,
        sidePadding: 10,
        bottomPadding: 10
      },
      enableExcelExport: true,
      enableExcelCopyBuffer: true,
      enableFilterTrimWhiteSpace: true,
      showCustomFooter: true, // display some metrics in the bottom custom footer
      enableContextMenu: true,
      enableCellMenu: true,
      forceFitColumns: true,

    };
    this.searchText = '';
    this.loadBenchMarkKPI();
    this.getDivisions();
    this.getDepartments();
    this.getTarget();
    this.getTrend();
    this.getReportVehicle();
    this.getStrategicObjective();
    this.getStrategicPriority();
    this.getslaStatusRule();
    this.getCondition();
    this.getFrequency();
    this.loadFrequency();
    this.getUsers();
    //BenchMark
    //this.loadYear();
    this.getBenchMarkYear();
    this.getSource();
    this.getPeer();
    this.getConsideration();
    this.getGeographicArea();
    this.getKPIBenchmarkEntry_Export(this.BMUno);
  }

  angularGridReady(angularGrid: AngularGridInstance) {
    this.angularGrid = angularGrid;
    this.userService.angularGrid = angularGrid;
  }

  CheckUserPermission() {

    let userPermissionData = this.userService.getUserRights("SLA KPIs");
    if (userPermissionData != null && userPermissionData != undefined && userPermissionData.length > 0) {
      if (userPermissionData[0].showPage == 1) {
        this.permision_add = (userPermissionData[0].showAdd == 1) ? true : false;
        this.permision_edit = (userPermissionData[0].showEdit == 1) ? true : false;
        this.permision_delete = (userPermissionData[0].showDelete == 1) ? true : false;


      }
      else {
        this.router.navigateByUrl('/access-denied');
      }
    }
    else {
      this.router.navigateByUrl('/access-denied');
    }
  }

  uniqueArray(arrayList, val, label) {
    var temp = this;
    var aList = [];
    if (arrayList) {
      for (var i = 0, l = arrayList.length; i < l; i++)
        if (aList.filter(item => item.label == temp.Checklabel(arrayList[i][label])).length == 0) {

          aList.push({
            'value': this.CheckValue(arrayList[i][val]), 'label': this.Checklabel(arrayList[i][label])
          });
        }
    }


    aList.sort((a: any, b: any) => {
      if (a['value'] < b['value']) {
        return -1;
      } else if (a['value'] > b['value']) {
        return 1;
      } else {
        return 0;
      }
    });
    return aList;
  }

  exportToExcel() {
    var temp = this;
    setTimeout(function () {
      temp.angularGrid.excelExportService.exportToExcel({
        filename: 'Export',
        format: FileType.xlsx,

      });
    }, 100)


  }


  Checklabel(val) {
    if (val != undefined && val != null && val != '' && val != ' ')
      return val.trim();
    else
      return ''

  }

  CheckValue(val) {
    if (val != undefined && val != null && val != '' && val != ':')
      return val;
    else
      return ' '

  }

  IsNull(val) {
    if (val != undefined && val != null && val != '') {
      val = val.trim()
      return val.charAt(0).toUpperCase() + val.slice(1);
    }
    else
      return ' '

  }
  searchGrid() {
    
    if (this.searchText != "") {
      this.dataset = this.dataSearch.filter(a =>
        a.kpiNameEn && a.kpiNameEn.toLowerCase().includes(this.searchText.toLowerCase())
        || (a.kpiCode && a.kpiCode.toLowerCase().includes(this.searchText.toLowerCase()))
        || (a.trendName && a.trendName.toLowerCase().includes(this.searchText.toLowerCase()))
        || (a.unitEn && a.unitEn.toLowerCase().includes(this.searchText.toLowerCase()))
        || (a.bmYear && a.bmYear.toLowerCase().includes(this.searchText.toLowerCase()))
        || (a.benchMarkableText && a.benchMarkableText.toLowerCase().includes(this.searchText.toLowerCase()))
        || (a.benchMarkedText && a.benchMarkedText.toLowerCase().includes(this.searchText.toLowerCase())));
    }
    else
      this.dataset = this.dataSearch;
  }
  setColnDefn() {
    let temp = this;
    this.columnDefinitions = [

      {
        id: 'kpiNameEn', name: 'KPI NameEn', field: 'kpiNameEn', sortable: true, type: FieldType.string, filterable: true, width: 150,
        filter: {
          collection: this.uniqueArray(this.dataset, 'kpiNameEn', 'kpiNameEn'),
          model: Filters.multipleSelect,

        }
      },
      {
        id: 'kpiNameAr', name: 'KPI NameAr', field: 'kpiNameAr', sortable: true, type: FieldType.string, filterable: true, width: 150,
        filter: {
          collection: this.uniqueArray(this.dataset, 'kpiNameAr', 'kpiNameAr'),
          model: Filters.multipleSelect,

        }
      },
      {
        id: 'formula', name: 'Formula ', field: 'formula', sortable: true, type: FieldType.string, filterable: true, width: 150,
        filter: {
          collection: this.uniqueArray(this.dataset, 'formula', 'formula'),
          model: Filters.multipleSelect,

        }
      },
      //{
      //  id: 'kpiCode', name: 'KPI Code', field: 'kpiCode', sortable: true,
      //  type: FieldType.string, filterable: true,
      //  filter: {
      //    collection: this.uniqueArray(this.dataset, 'kpiCode', 'kpiCode'),
      //    model: Filters.multipleSelect,
      //  }
      //},
      {
        id: 'unitEn', name: 'Unit', field: 'unitEn', sortable: true, type: FieldType.string, filterable: true,
        filter: {
          collection: this.uniqueArray(this.dataset, 'unitEn', 'unitEn'),
          model: Filters.multipleSelect,
        }
      },
      {
        id: 'trendName', name: 'Desired Trend', field: 'trendName', sortable: true, type: FieldType.string, filterable: true,
        filter: {
          collection: this.uniqueArray(this.dataset, 'trendName', 'trendName'),
          model: Filters.multipleSelect,
        }
      },
      //{
      //  id: 'formula', name: 'Formula', field: 'formula', sortable: true, type: FieldType.string, filterable: true,
      //  filter: {
      //    collection: this.uniqueArray(this.dataset, 'formula', 'formula'),
      //    model: Filters.multipleSelect,
      //  }
      //},
      {
        id: 'reportingDivisionName', name: 'Business Division', field: 'reportingDivisionName', sortable: true, type: FieldType.string, filterable: true,
        filter: {
          collection: this.uniqueArray(this.dataset, 'reportingDivisionName', 'reportingDivisionName'),
          model: Filters.multipleSelect,
        }
      },
      {
        id: 'strategicPriority', name: 'Strategic Priority ', field: 'strategicPriority', sortable: true, type: FieldType.string, filterable: true,
        filter: {
          collection: this.uniqueArray(this.dataset, 'strategicPriority', 'strategicPriority'),
          model: Filters.multipleSelect,
        }
      },
      {
        id: 'bmEntry', name: 'Benchmarked ', field: 'bmEntry', sortable: true, type: FieldType.string, filterable: true,
        filter: {
          collection: this.uniqueArray(this.dataset, 'bmEntry', 'bmEntry'),
          model: Filters.multipleSelect,
        }
      },
      //{
      //  id: 'bmYear', name: 'Last Year', field: 'bmYear', sortable: true, type: FieldType.string, filterable: true,
      //  filter: {
      //    collection: this.uniqueArray(this.dataset, 'bmYear', 'bmYear'),
      //    model: Filters.multipleSelect,
      //  }
      //},
      //{
      //  id: 'formula', name: 'Formula', field: 'formula', sortable: true, type: FieldType.string, filterable: true,
      //  filter: {
      //    collection: this.uniqueArray(this.dataset, 'formula', 'formula'),
      //    model: Filters.multipleSelect,
      //  }
      //},
      //{
      //  id: 'benchMarkable', name: 'Benchmarkable', field: 'benchMarkableText', sortable: true, type: FieldType.string, filterable: true,
      //  filter: {
      //    collection: this.uniqueArray(this.dataset, 'benchMarkableText', 'benchMarkableText'),
      //    model: Filters.multipleSelect,
      //  }
      //},
      //{
      //  id: 'benchMarked', name: 'Benchmarked', field: 'benchMarkedText', sortable: true, type: FieldType.string, filterable: true,
      //  filter: {
      //    collection: this.uniqueArray(this.dataset, 'benchMarkedText', 'benchMarkedText'),
      //    model: Filters.multipleSelect,
      //  }
      //},
      //{
      //  id: 'slaRuleName', name: 'KPI Type', field: 'slaRuleName', selectable: false, type: FieldType.string, filterable: true,
      //  filter: {
      //    collection: this.uniqueArray(this.dataset, 'slaRuleName', 'slaRuleName'),
      //    model: Filters.multipleSelect,
      //  }
      //},
      //{
      //  id: 'scheduleName', name: 'Frequency', field: 'scheduleName', sortable: true, type: FieldType.string, filterable: true,
      //  filter: {
      //    collection: this.uniqueArray(this.dataset, 'scheduleName', 'scheduleName'),
      //    model: Filters.multipleSelect,
      //  }
      //},
      //{
      //  id: 'report', name: 'Reporting Division', field: 'reportingDivisionName', width: 100, sortable: true, type: FieldType.string, filterable: true,
      //  filter: {
      //    collection: this.uniqueArray(this.dataset, 'reportingDivisionName', 'reportingDivisionName'),
      //    model: Filters.multipleSelect,
      //  },
      //},
      {
        id: 'action', name: 'Action', field: 'action', cssClass: 'blue', width: 50,
        excludeFromExport: true,
        formatter: this.actionFormatter,
        cellMenu: {
          hideCloseButton: false,
          commandTitleKey: 'COMMANDS',
          commandItems: [
            {
              command: 'delete-row', titleKey: 'EDIT_ROW', positionOrder: 64, title: 'Edit Benchmark KPI',
              itemVisibilityOverride: (args: MenuCallbackArgs) => {
                let data = args.dataContext;

                if (this.isBMChampion || this.isBMVisitor)
                  return false;
                else return true;
              },
              iconCssClass: 'fa fa-pencil-square-o', cssClass: 'blue', textCssClass: 'bold',
              action: (e, args) => {
                this.pageAction = 'edit';
                this.selectedfrequencyUno = 0;
                this.submitted = false;
                

                for (let x = 0; x < this.geographicAreaList.length; x++) {
                    this.geographicAreaList[x].checked = false;
                }

                if (this.permission == 1) {

                  let rdata: any = args.dataContext;
                  this.selectedKPI = rdata.kpiNameEn;
                  this.selTab = true;
                  this.selected_kpiCode = rdata.kpiCode;
                  this.objBenchmarkKPI = this.kpiData.filter((items: any) => items.kpiUno == rdata.id)[0];
                  this.objBenchmarkKPI.slaRuleUno = 1;
                  this.objBenchmarkKPI.frequencyUno = 2;
                  this.objBenchmarkKPI.dataOwnerUno = (this.objBenchmarkKPI.dataOwnerUno) ? this.utilityService.CommaSeperatorToArray(this.objBenchmarkKPI.dataOwnerUno.toString()) : [];
                  this.objBenchmarkKPI.level1ApproverUno = (this.objBenchmarkKPI.level1ApproverUno) ? this.utilityService.CommaSeperatorToArray(this.objBenchmarkKPI.level1ApproverUno.toString()) : [];
                  this.objBenchmarkKPI.level2ApproverUno = (this.objBenchmarkKPI.level2ApproverUno) ? this.utilityService.CommaSeperatorToArray(this.objBenchmarkKPI.level2ApproverUno.toString()) : [];
                  this.objBenchmarkKPI.level3ApproverUno = (this.objBenchmarkKPI.level3ApproverUno) ? this.utilityService.CommaSeperatorToArray(this.objBenchmarkKPI.level3ApproverUno.toString()) : [];
                  this.objBenchmarkKPI.strategicObjectiveUno = (this.objBenchmarkKPI.strategicObjectiveUno) ? this.utilityService.CommaSeperatorToArrayParseInt(this.objBenchmarkKPI.strategicObjectiveUno.toString()) : [];
                  this.objBenchmarkKPI.strategicPriorityUno = (this.objBenchmarkKPI.strategicPriorityUno) ? this.utilityService.CommaSeperatorToArrayParseInt(this.objBenchmarkKPI.strategicPriorityUno.toString()) : [];
                  
                  //this.isReportingVehicle = this.objBenchmarkKPI.isUnderBSC == true ? true : false;
                  //this.currentlyChecked = this.objBenchmarkKPI.areaUno;

                  //this.year1Value = this.objBenchmarkKPI.year1Value;
                  //this.year2Value = this.objBenchmarkKPI.year2Value;
                  //this.year3Value = this.objBenchmarkKPI.year3Value;

                  //this.year1Label = this.objBenchmarkKPI.year1Label;
                  //this.year2Label = this.objBenchmarkKPI.year2Label;
                  //this.year3Label = this.objBenchmarkKPI.year3Label;

                  //let editAreaItems:any = [];
                  //editAreaItems = this.objBenchmarkKPI.areaUno != null && this.objBenchmarkKPI.areaUno != undefined && this.objBenchmarkKPI.areaUno != '' ? this.objBenchmarkKPI.areaUno.split(',') : [];

                  

                  //if (editAreaItems.length > 0) {
                  //  let items = [];
                  //  for (var i = 0; i < editAreaItems.length; i++) {
                  //    items.push({
                  //      id: editAreaItems[i],
                  //      text: '',
                  //      checked: true
                  //    });
                  //  }
                  //  this.editSelectedAreaItems = items;
                  //}

                  //this.selectedAreaItems = [];
                  //for (let i = 0; i < this.editSelectedAreaItems.length; i++) {
                  //  for (let x = 0; x < this.geographicAreaList.length; x++) {
                  //    if (this.geographicAreaList[x].id == this.editSelectedAreaItems[i].id) {
                  //      this.geographicAreaList[x].checked = true;
                  //      this.selectedAreaItems.push(this.editSelectedAreaItems[i]);
                  //    }
                  //  }
                  //}

                  if (this.pageAction == 'edit') {
                    
                    this.selectedfrequencyUno = rdata.slaRuleUno;
                    let divisionUno = (rdata.businessDivisionUno != null && rdata.businessDivisionUno != '') ? rdata.businessDivisionUno : 0;
                    if (this.checkbox_filter) {
                      this.user_data_filter = this.user_data.filter(
                        user => user.divisionUno === divisionUno);
                      this.dataEntry_data_filter = this.dataEntry_data.filter(
                        user => user.divisionUno === divisionUno);
                    }
                  }
                  this.modalRef = this.modalService.show(
                    this.addtemplate,
                    Object.assign({}, {
                      class: 'gray modal-lg',
                      backdrop: true,
                      keyboard: true,
                      focus: true,
                      show: false,
                      ignoreBackdropClick: true,
                      animated: true
                    })
                  );
                }
              },
              // only show command to 'Delete Row' when the task is not completed

            },
            { divider: true, command: '', positionOrder: 63 },

            {
              command: 'entry-row', titleKey: 'Entry_ROW', positionOrder: 65, title: 'Benchmark Entry',
              iconCssClass: 'fa fa-plus-circle', cssClass: 'blue', textCssClass: 'bold',
              itemVisibilityOverride: (args: MenuCallbackArgs) => {
                let rdata = args.dataContext;
                this.objBenchmarkKPI = this.kpiData.filter((items: any) => items.kpiUno == rdata.id)[0];
                if (this.objBenchmarkKPI.benchMarkable) {
                  if (this.isBMChampion || this.isBMVisitor)
                    return false;
                  else return true;
                }
                else { return false };
              },
              action: (e, args) => {
                this.pageAction = 'entry';

                let rdata: any = args.dataContext;
                this.selectedItemID = rdata.id;
                this.selectedKPI = rdata.kpiNameEn;
                /*this.getKPIBenchmarkEntry_Export(rdata.id);*/
                this.objBenchmarkKPI = this.kpiData.filter((items: any) => items.kpiUno == rdata.id)[0];
                //If Benchmark Transaction Kpi data is avaiable,the bind the value in the entryform
                
                //this.getTranBenchmarkKPI(this.selectedItemID);
                this.selectedItemBenchmarkable = this.objBenchmarkKPI.benchMarkable;
                this.getBenchmarkKPIEntry(this.selectedItemID);
                //this.clearEntryForm();
                this.modalRef = this.modalService.show(
                  this.entrytemplate,
                  Object.assign({}, {
                    class: 'gray modal-lg',
                    backdrop: true,
                    keyboard: true,
                    focus: true,
                    show: false,
                    ignoreBackdropClick: true,
                    animated: true
                  })
                );
              }
            },
            { divider: true, command: '', positionOrder: 66 },
            {
              command: 'delete-row', titleKey: 'DELETE_ROW', positionOrder: 66, title: 'Delete',
              itemVisibilityOverride: (args: MenuCallbackArgs) => {
                let data = args.dataContext;

                if (this.isBMChampion || this.isBMVisitor)
                  return false;
                else return true;
              },
              iconCssClass: 'fa fa-trash', cssClass: 'red', textCssClass: 'bold',
              action: (e, args) => {
                Swal.fire({
                  title: 'Delete',
                  text: 'Please confirm to delete the record',
                  type: 'warning',
                  showCancelButton: true,
                  confirmButtonText: 'Ok',
                  cancelButtonText: 'Cancel'
                }).then((result) => {
                  if (result.value) {
                    this.pageAction = 'delete';
                    this.DeleteBenchMarkKPI(args.dataContext);
                  } else if (result.dismiss === Swal.DismissReason.cancel) {

                  }
                })
              },
              // only show command to 'Delete Row' when the task is not completed

            },

            { divider: true, command: '', positionOrder: 67 },
            {
              command: 'kpiinfo-row', titleKey: 'KPIINFO_ROW', positionOrder: 69, title: 'KPI Info',
              //itemVisibilityOverride: (args: MenuCallbackArgs) => {
              //  let data = args.dataContext;

              //  if (!this.isBMTeam)
              //    return true;
              //  else return false;
              //},
              iconCssClass: 'fa fa-line-chart', cssClass: 'blue', textCssClass: 'bold',
              action: (e, args) => {
                let rdata: any = args.dataContext;
                
                this.router.navigateByUrl('/benchmarkkpiinfo/' + rdata.id);
              },


            },

          ],
        }
      }




    ]


  }

  actionFormatter: Formatter = (row, cell, value, columnDef, dataContext) => {
    return `<div class="fake-hyperlink"> <i class="fa fa-ellipsis-h fa-lg"></i></div>`;
  };


  // Get BenchMarkKPI list
  loadBenchMarkKPI() {
    this.spinner.show();
    
    let inpValue = new benchmarkkpi();
    inpValue.languageUno = 1033;
    inpValue.itemUno = 0;
    inpValue.condition = 1;
    inpValue.tenantUno = this.tenantUno;
    inpValue.userUno = this.login_UserID;
    inpValue.frequencyUno = this.frequencyUnofilter ? this.frequencyUnofilter : 0;
    inpValue.slaRuleUno = this.slaUnofilter ? this.slaUnofilter : 0;
    inpValue.businessDivisionUno = this.divisionUnofilter ? this.divisionUnofilter : 0;
    inpValue.reportingDivisionUno = (this.divisionUnoSecondaryfilter) ? this.divisionUnoSecondaryfilter : 0;

    this.restapiBM.getBenchMarkKPIs(inpValue)
      .subscribe(data => {
        
        this.data = uniqBy(data, 'kpiUno');

        this.data = (this.isBMTeam) ? this.data.filter(x => x.benchMarked === true) : this.data;

        const mockDataset = [];
        for (let i = 0; i < this.data.length; i++) {

          mockDataset[i] = {
            id: this.data[i].kpiUno,
            kpiCode: this.data[i].kpiCode,
            kpiNameEn: this.data[i].kpiNameEn,
            kpiNameAr: this.data[i].kpiNameAr,
            unitEn: this.data[i].unitEn,
            trendName: this.data[i].trendName,
            targetName: this.data[i].targetName,
            slaRuleName: this.data[i].slaRuleName,
            scheduleName: this.data[i].scheduleName,
            reportingDivisionName: this.data[i].divisionName,
            benchMarkable: this.data[i].benchMarkable,
            benchMarked: this.data[i].benchMarked,
            benchMarkableText: this.data[i].benchMarkableText,
            benchMarkedText: this.data[i].benchMarkedText,
            formula: this.data[i].formula,
            strategicPriority: this.data[i].strategicPriority,
            bmYear: (this.data[i].bmYear != "") ? this.data[i].bmYear : " - ",
            bmEntry: this.data[i].benchmarkEntry
          };

        }
        this.dataset = mockDataset;
        this.dataSearch = mockDataset;
        if (mockDataset.length > 0) {
          this.setColnDefn();
        }
        this.kpiData = this.data
        this.isStart = false;
        this.loading = false;
        this.spinner.hide()
      },
        (error) => {
          //Called when error
          this.spinner.hide();
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
        this.spinner.hide();
      });
  }



  getDivisions() {

    let inpValue = new division();
    inpValue.userUno = this.login_UserID;
    inpValue.languageUno = 1033;
    inpValue.itemUno = 0;
    inpValue.condition = 5;
    inpValue.tenantUno = this.tenantUno;
    this.restapiBM.getDivisions(inpValue)
      .subscribe(data => {
        
        this.division_data = data;
      },
        (error) => {
          //Called when error
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
      });
  }

  getDepartments() {

    let inpValue = new department();
    inpValue.languageUno = 1033;
    inpValue.itemUno = 0;
    inpValue.condition = 1;
    inpValue.tenantUno = this.tenantUno;
    inpValue.userUno = this.login_UserID;
    this.restapiBM.getDepartments(inpValue)
      .subscribe(data => {

        this.department_data = data;
      },
        (error) => {
          //Called when error
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
      });
  }

  getTarget() {
    
    let inpValue = new targetMaster();
    inpValue.languageUno = 1033;
    inpValue.itemUno = 0;
    inpValue.condition = 1;
    inpValue.tenantUno = this.tenantUno;
    inpValue.userUno = this.login_UserID;
    this.restapiBM.GetTargetInfo(inpValue)
      .subscribe(data => {
        
        this.target_data = data;
      },
        (error) => {
          //Called when error
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
      });
  }

  getTrend() {
    this.trend_data = [
      { trendUno: 1, trendName: 'Achievement' },
      { trendUno: 2, trendName: 'Reduction' }
    ];
  }

  getReportVehicle() {
    this.reportVehicle_data = [
      { reportVehicleUno: 1, reportVehicleName: 'Corporate BSC' },
      { reportVehicleUno: 2, reportVehicleName: 'Divisional BSC' },
      { reportVehicleUno: 3, reportVehicleName: 'Not Applicable' }
    ];
  }

  getslaStatusRule() {
    this.slaStatusRule_data = [
      { slaStatusRuleUno: 1, slaStatusRuleName: 'Range' },
      { slaStatusRuleUno: 2, slaStatusRuleName: 'Variance' },
      { slaStatusRuleUno: 3, slaStatusRuleName: '0 - Target' },
      { slaStatusRuleUno: 4, slaStatusRuleName: 'Text' }
    ];
  }
  getCondition() {
    this.condition2_data = [
      { text: '>', value: '>' },
      { text: '>=', value: '>=' },
      { text: '=', value: '=' },
      { text: '<', value: '<' },
      { text: '<=', value: '<=' }
    ];
  }

  getFrequency() {
    this.frequency_data = [
      { frequencyCode: 1, frequencyName: 'Yearly' },
      { frequencyCode: 2, frequencyName: 'Semi-annually' },
      { frequencyCode: 3, frequencyName: 'Quarterly' }
      //{ frequencyCode: 4, frequencyName: 'Monthly' }
    ];
  }

  getUsers() {

    let inpValue = new user();
    inpValue.languageUno = 1033;
    inpValue.itemUno = 0;
    inpValue.condition = 0;
    inpValue.userUno = this.login_UserID;
    inpValue.tenantUno = this.tenantUno;
    this.restapiBM.getUsers(inpValue)
      .subscribe(data => {
        
        this.user_data = data;
        this.dataEntry_data = data;
        this.user_data_filter = data;
        this.dataEntry_data_filter = data;
      },
        (error) => {
          //Called when error
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
      });
  }




  AddEditBenchMarkKPI(data1: any) {
    
    //if (this.kpiForm.invalid) {
    //  Swal.fire('Error', 'Something went wrong!', 'error')
    //  return false;
    //}

    

    if (this.DuplicateNameCheck(this.utilityService.isStringNull(data1.kpiCode), this.utilityService.isNumericNull(data1.kpiUno), this.utilityService.isStringNull(data1.kpiNameEn), this.utilityService.isStringNull(data1.kpiNameAr))) {
      //Swal.fire('Error', 'Duplicates are not allowed', 'warning');
      this.toaster.show('warning', 'Warning', 'Duplicate values are not allowed.');
      return false;
    }
    else {
      //GeoGrapicArea
      let selectedArea: any = [];
      let finalArea = '';
      for (let i = 0; i < this.selectedAreaItems.length; i++) {
        selectedArea.push(this.selectedAreaItems[i].id);
      }
      finalArea = (selectedArea.length>0) ? selectedArea.toString() : '';


      let objKPI = new benchmarkkpi();
      objKPI = data1
      objKPI.dataOwnerUno = (objKPI.dataOwnerUno) ? objKPI.dataOwnerUno.toString() : '';
      objKPI.level1ApproverUno = (objKPI.level1ApproverUno) ? objKPI.level1ApproverUno.toString() : '';
      objKPI.level2ApproverUno = (objKPI.level2ApproverUno) ? objKPI.level2ApproverUno.toString() : '';
      objKPI.level3ApproverUno = (objKPI.level3ApproverUno) ? objKPI.level3ApproverUno.toString() : '';
      objKPI.strategicObjectiveUno = (objKPI.strategicObjectiveUno) ? objKPI.strategicObjectiveUno.toString() : '';
      objKPI.strategicPriorityUno = (objKPI.strategicPriorityUno) ? objKPI.strategicPriorityUno.toString() : '';
      objKPI.actionType = this.pageAction;
      objKPI.kpiUno = (this.pageAction == "add") ? 0 : this.utilityService.isNumericNull(data1.kpiUno);
      objKPI.slaUno = 1;
      objKPI.userUno = this.login_UserID;
      objKPI.condition = (this.pageAction == "add") ? 0 : 1;
      objKPI.tenantUno = this.tenantUno;
      objKPI.currentYear = this.currentYear;
      objKPI.benchMarkable = this.isBenchMarkable;
      objKPI.trendName = this.trendName;
      this.restapiBM.addEditBenchMarkKPI(objKPI)
        .subscribe(data => {

          if (data != null && data != undefined && data != '') {
            //Swal.fire('Error', 'Something went wrong', 'error');
            this.toaster.show('error', 'Error', 'Something went wrong');
            this.spinner.hide();
          }
          else {

            this.toaster.show('success', 'Success', (this.pageAction == "add") ? 'Benchmark KPI saved.' : 'Benchmark KPI updated.');
            //Swal.fire({
            //  type: 'success',
            //  title: 'Bench Mark KPI saved.',
            //  showConfirmButton: false,
            //  timer: 1500
            //})
            this.modalRef.hide();
            this.currentlyChecked = 0;
            this.year1Value = '';
            this.year2Value = '';
            this.year3Value = '';
            setTimeout(() => { this.spinner.hide(); this.loadBenchMarkKPI(); }, 900);

          }



        },
          (error) => {
            //Called when error
            this.spinner.hide();
          }
        ).add(() => {
          //Called when operation is complete (both success and error)
          //this.spinner.hide();
        });
      return true;
    }
  }
  DuplicateNameCheck(kpiCode: string, kpiUno: number, kpiNameEn: string, kpiNameAr: string) {
    if (this.data != null && this.data != undefined) {
      var rtnValue = false;
      this.data.forEach((grdData) => {


        if (((kpiUno != grdData.kpiUno) || (kpiUno == grdData.kpiUno && this.selected_kpiCode != grdData.kpiCode))
          &&
          (grdData.kpiCode.trim().toLowerCase() + grdData.kpiNameEn.toLocaleLowerCase() == kpiCode.trim().toLowerCase() + kpiNameEn.toLocaleLowerCase())) {
          rtnValue = true;
        }

      });

      return rtnValue;
    }
  }


  DeleteBenchMarkKPI(data1: any) {

    let objBenchmark = new benchmarkkpi();
    objBenchmark.actionType = this.pageAction;
    objBenchmark.kpiUno = data1.id;
    objBenchmark.userUno = this.login_UserID;
    objBenchmark.tenantUno = this.tenantUno;

    this.restapiBM.deleteBenchMarkKPI(objBenchmark)
      .subscribe(data => {
        
        if (data != null && data != undefined && data != '') {
          //Swal.fire('Error', 'Something went wrong!', 'error')
          this.toaster.show('error', 'Error', 'Something went wrong');
        }
        else {
          //Swal.fire({
          //  type: 'success',
          //  title: 'BenchMark KPI deleted.',
          //  showConfirmButton: false,
          //  timer: 1500
          //})

          this.toaster.show('success', 'Success', 'Benchmark KPI Deleted.');
          this.loadBenchMarkKPI();
        }


        this.spinner.hide();
      },
        (error) => {
          //Called when error
          this.spinner.hide();
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
        this.spinner.hide();
      });

  }



  public focusIn(target: HTMLElement): void {
    target.parentElement.classList.add('e-input-focus');
  }

  public focusOut(target: HTMLElement): void {
    target.parentElement.classList.remove('e-input-focus');
  }


  onfilterData(ev: any) {
    
    this.objBenchmarkKPI.dataOwnerUno = [];
    this.objBenchmarkKPI.level1ApproverUno = [];
    this.objBenchmarkKPI.level2ApproverUno = [];
    this.objBenchmarkKPI.level3ApproverUno = [];

    if (ev.currentTarget.checked) {
      this.user_data_filter = this.user_data.filter(
        user => user.divisionUno === this.divisionUno_filter);
      this.dataEntry_data_filter = this.dataEntry_data.filter(
        user => user.divisionUno === this.divisionUno_filter);
      this.checkbox_filter = true;
    }
    else {
      this.user_data_filter = this.user_data;
      this.dataEntry_data_filter = this.user_data;
      this.checkbox_filter = false;

    }
  }

  onBenchMarkData(ev: any) {
    

    if (ev.currentTarget.checked) {
      this.isBenchMarkable = true;
    }
    else {
      this.isBenchMarkable = false;

    }
  }
  isUnderBSCChecked(ev: any) {
    

    if (ev.currentTarget.checked) {
      this.isReportingVehicle = true;
    }
    else {
      this.isReportingVehicle = false;

    }
  }
  selectCheckBox(targetType: any) {
    this.objBenchmarkKPI.areaUno = targetType;
    // If the checkbox was already checked, clear the currentlyChecked variable
    if (this.currentlyChecked === targetType) {
      this.currentlyChecked = '';
      return;
    }

    this.currentlyChecked = targetType;
  }
  isGeographicAreasChecked(ev: any) {
    

    if (ev.currentTarget.checked) {
      this.isReportingVehicle = true;
    }
    else {
      this.isReportingVehicle = false;

    }
  }
  onchangeDivision(e) {
    
    // this.AutoCompleteObj.value = "";
    // this.level1ApproverUno. = "";
    this.value_inpdataEntryUno = [];
    this.value_level1ApproverUno = [];
    this.value_level2ApproverUno = [];
    this.value_level3ApproverUno = [];
    let divisionUno = (e.currentTarget != null && e.currentTarget.value != null) ? parseInt(e.currentTarget.value) : 0;
    this.divisionUno_filter = divisionUno;
    if (this.checkbox_filter) {
      this.user_data_filter = this.user_data.filter(
        user => user.divisionUno === divisionUno);
      this.dataEntry_data_filter = this.dataEntry_data.filter(
        user => user.divisionUno === divisionUno);
    } else { this.user_data_filter = this.user_data; }

  }




  loadFrequency() {
    this.frequency_data = [
      { frequencyCode: 1, frequencyName: 'Yearly' },
      { frequencyCode: 2, frequencyName: 'Semi-annually' },
      { frequencyCode: 3, frequencyName: 'Quarterly' }
    ];
  }


  // Choose city using select dropdown
  searchSLA() {
    
    let temp = this;
    this.spinner.show();
    if (!this.isStart) {
      setTimeout(function () { temp.loadBenchMarkKPI(); }, 1000)

    }
  }




  onChangeFreq(args): void {
    
    this.selectedfrequencyUno = args.value;
  }


  openModalWithClass() {
    
    this.pageAction = "add";
    this.selectedKPI = '';
    this.objBenchmarkKPI = new benchmarkkpi();
    this.objBenchmarkKPI.slaRuleUno = 1;
    this.objBenchmarkKPI.frequencyUno = 2;
    this.objBenchmarkKPI.dataOwnerUno = [];
    this.objBenchmarkKPI.level1ApproverUno = [];
    this.objBenchmarkKPI.level2ApproverUno = [];
    this.objBenchmarkKPI.level3ApproverUno = [];
    this.objBenchmarkKPI.benchMarkable = false;
    this.objBenchmarkKPI.year1Value = null;
    this.objBenchmarkKPI.year2Value = null;
    this.objBenchmarkKPI.year3Value = null;
    this.selTab = true;
    this.modalRef = this.modalService.show(
      this.addtemplate,
      Object.assign({}, {
        class: 'gray modal-lg',
        backdrop: true,
        keyboard: true,
        focus: true,
        show: false,
        ignoreBackdropClick: true,
        animated: true
      })
    );
  }


  getBooleanValue(checkboxSelector) {
    return document.querySelector(checkboxSelector).checked;
  }
  onNext(val) {
    
    if (val) {
      this.selTab = false;
    }
    else {
      // Swal.fire('Error', 'Please enter the General Information.', 'error')
      this.toaster.show('warning', 'Warning', 'Please enter all the required fields in General Information tab.');
    }
  }
  onSubmit(val1, val2) {
    
    this.submitted = true;
    
    if (!val1 && !val2) {
      //Swal.fire('Error', 'Please enter the required information.', 'error');
      this.toaster.show('warning', 'Warning', 'Please enter all the required fields.');
      return;
    }
    else if (!val1) {

      //Swal.fire('Error', 'Please enter the Accountability Information.', 'error');
      this.toaster.show('warning', 'Warning', 'Please enter all the required fields in Accountability Info tab.');
      return;
    }
    else if (!val2) {
      //Swal.fire('Error', 'Please enter the General Information.', 'error');
      this.toaster.show('warning', 'Warning', 'Please enter all the required fields.');
      this.selTab = true;
    }
    else if ((this.objBenchmarkKPI.dataOwnerUno.length == 0) || (this.objBenchmarkKPI.level1ApproverUno.length == 0)) {
      return false;
    }
    else {
      this.submitted = false;
      this.AddEditBenchMarkKPI(this.objBenchmarkKPI)
    }
  }

  getTranBenchmarkKPI(itemUno: any) {
    
    this.isTranData = false;
    let inpValue = new tranbenchmarkkpi();
    inpValue.languageUno = 1033;
    inpValue.itemUno = itemUno;
    inpValue.condition = 2;
    inpValue.userUno = this.login_UserID;
    this.objTranBenchmarkKPI = new tranbenchmarkkpi();
    this.restapiBM.getTranBenchMarkKPIs(inpValue)
      .subscribe((data: any) => {
        
        let rtn_data = data;
        if (rtn_data != null && rtn_data.length > 0) {

          this.objTranBenchmarkKPI = rtn_data[0];
          this.isTranData = true;
        }
      },
        (error) => {
          //Called when error
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
      });
  }


  getBenchmarkKPIEntry(itemUno: any) {
    
    this.isBenchmarkloading = true;
    this.searchBecnhmarkListText = "";
    this.clearEntryForm();
    let inpValue = new tranbenchmarkkpi();
    inpValue.languageUno = 1033;
    inpValue.itemUno = itemUno;
    inpValue.condition = 2;
    inpValue.userUno = this.login_UserID;
    inpValue.tenantUno = this.tenantUno;
    this.BMUno = itemUno;
    this.multipleBemchMarkEntry = [];
    this.benchMarkList = [];
    this.isSearchTxtBox = true;
   
    this.restapiBM.getBenchMarkKPIEntry(inpValue)
      .subscribe((data: any) => {
        
        let rtn_data = data;
        if (rtn_data != null && rtn_data.length > 0) {

          //this.multipleBemchMarkEntry = rtn_data;

          for (var i = 0; i < rtn_data.length; i++) {
            let source_text = (rtn_data[i].sourceUno > 0) ? this.source_data.filter((items: any) => items.id == rtn_data[i].sourceUno)[0].titleNameEn : '-';

           /* let peer_text = (rtn_data[i].peerUno > 0) ? this.peer_data.filter((items: any) => items.id == rtn_data[i].peerUno)[0].titleNameEn : '-';*/

            let peer_text = '-';
            let peerArr = [];
            if (rtn_data[i].peerUno > 0) {
              peerArr = this.peer_data.filter((items: any) => items.id == rtn_data[i].peerUno);
              if (peerArr.length > 0) {
                peer_text = peerArr[0].titleNameEn;
              }
            }

            /*let consideration_text = (rtn_data[i].considerationUno > 0) ? this.consideration_data.filter((items: any) => items.id == rtn_data[i].considerationUno)[0].titleNameEn : '-';*/

            let consideration_text = '-';
            let considerationArr = [];
            if (rtn_data[i].considerationUno > 0) {
              considerationArr = this.consideration_data.filter((items: any) => items.id == rtn_data[i].considerationUno);
              if (considerationArr.length > 0) {
                consideration_text = considerationArr[0].titleNameEn;
              }
            }
            
            let objBenchmarkEntry = {
              kpiUno: this.selectedItemID,
              benchmarkYear: rtn_data[i].benchmarkYear,
              benchmarks: rtn_data[i].benchmarks,
              sourceUno: rtn_data[i].sourceUno,
              peerUno: rtn_data[i].peerUno,
              considerationUno: rtn_data[i].considerationUno,
              filter: rtn_data[i].filter,
              targetValue: rtn_data[i].targetValue,
              actualValue: rtn_data[i].actualValue,
              source_text: source_text,
              peer_text: peer_text,
              consideration_text: consideration_text,
              id: rtn_data[i].id
            }

            this.multipleBemchMarkEntry.push(objBenchmarkEntry);
          }

          this.benchMarkList = this.multipleBemchMarkEntry;
          this.isBenchmarkloading = false;
        }
        else {
          this.multipleBemchMarkEntry = [];
          this.benchMarkList = [];
          this.isSearchTxtBox = false;
          this.isBenchmarkloading = false;
        }
      },
        (error) => {
          //Called when error
          this.multipleBemchMarkEntry = [];
          this.benchMarkList = [];
          this.isSearchTxtBox = false;
          this.isBenchmarkloading = false;
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
      });
  }
  getSource() {
    let inpValue = new performancemaster();
    inpValue.languageUno = 1033;
    inpValue.itemUno = 0;
    inpValue.condition = 1;
    inpValue.userUno = this.login_UserID;
    inpValue.tenantUno = this.tenantUno;
    inpValue.tableName = 'source';
    this.restAdminApi.getPerformanceMaster(inpValue)
      .subscribe(data => {
        this.source_data = data;
      },
        (error) => {
          //Called when error
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
      });
  }

  getBenchMarkYear() {
    
    let date = new Date();
    //let pastYear = date.getFullYear() - 15;
    //let currentYear = date.getFullYear();
    //let futureYear = date.getFullYear() + 1;


    //this.benchMarkYear_data = [
    //  { text: pastYear, value: pastYear },
    //  { text: currentYear, value: currentYear },
    //  { text: futureYear, value: futureYear }
    //];

    let StartYear = 2010;
    let EndYear = Number(this.currentYear) + 2;//date.getFullYear() + 2;
    let yearCount = EndYear - 2011;
    this.benchMarkYear_data = [];
    for (let i = 0; i < yearCount; i++) {
      this.benchMarkYear_data.push({ text: StartYear + i, value: StartYear + i });
    }

    this.benchMarkYear_data = this.benchMarkYear_data.reverse();
  }
  getConsideration() {
    

    let inpValue = new performancemaster();
    inpValue.languageUno = 1033;
    inpValue.itemUno = 0;
    inpValue.condition = 1;
    inpValue.userUno = this.login_UserID;
    inpValue.tenantUno = this.tenantUno;
    inpValue.tableName = 'consideration';
    this.restAdminApi.getPerformanceMaster(inpValue)
      .subscribe(data => {
        this.consideration_data = data;
      },
        (error) => {
          //Called when error
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
      });

  }
  getPeer() {


    let inpValue = new performancemaster();
    inpValue.languageUno = 1033;
    inpValue.itemUno = 0;
    inpValue.condition = 1;
    inpValue.userUno = this.login_UserID;
    inpValue.tenantUno = this.tenantUno;
    inpValue.tableName = 'peer';
    this.restAdminApi.getPerformanceMaster(inpValue)
      .subscribe(data => {
        this.peer_data = data;
      },
        (error) => {
          //Called when error
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
      });

  }


  getStrategicObjective() {
    let inpValue = new performancemaster();
    inpValue.languageUno = 1033;
    inpValue.itemUno = 0;
    inpValue.condition = 1;
    inpValue.userUno = this.login_UserID;
    inpValue.tableName = 'strategic objective';
    inpValue.tenantUno = this.tenantUno;
    this.restAdminApi.getPerformanceMaster(inpValue)
      .subscribe(data => {
        this.StrategicObjective_data = data;
        this.strategicObjective_data_filter = data;
      },
        (error) => {
          //Called when error
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
      });
  }
  getStrategicPriority() {
    let inpValue = new performancemaster();
    inpValue.languageUno = 1033;
    inpValue.itemUno = 0;
    inpValue.condition = 1;
    inpValue.userUno = this.login_UserID;
    inpValue.tableName = 'strategic priority';
    inpValue.tenantUno = this.tenantUno;
    this.restAdminApi.getPerformanceMaster(inpValue)
      .subscribe(data => {
        this.StrategicPriority_data = data;
        this.strategicPriority_data_filter = data;
      },
        (error) => {
          //Called when error
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
      });
  }
  onchangeBenchMarkYear(e) {

  }
  onchangeSource(e) {

  }

  onchangePeer(e) {

  }

  onchangeConsideration(e) {

    //let divisionUno = (e.itemData != null && e.itemData.divisionUno != null && e.itemData.divisionUno != '') ? e.itemData.divisionUno : 0;
    //this.divisionUno_filter = divisionUno;
    //if (this.checkbox_filter) {
    //  this.user_data_filter = this.user_data.filter(
    //    user => user.divisionUno === divisionUno);
    //  this.dataEntry_data_filter = this.dataEntry_data.filter(
    //    user => user.divisionUno === divisionUno);
    //} else { this.user_data_filter = this.user_data; }
  }

  addBenchMarkEntry() {

    
    let flag = this.benchmarkbtn;
    let objBMKpi = new tranbenchmarkkpi();
    objBMKpi.itemUno = this.BMUno;
    objBMKpi.benchmarkYear = this.benchmarkYear;
    objBMKpi.sourceUno = this.sourceUno;
    objBMKpi.peerUno = this.peerUno;
    objBMKpi.considerationUno = this.considerationUno;
    objBMKpi.filter = this.filter;
    objBMKpi.targetValue = this.targetValue;
    objBMKpi.actualValue = this.actualValue;
    objBMKpi.userUno = this.login_UserID;
    objBMKpi.id = this.benchmarkbtn == 'Update' ? this.id : 0;
    objBMKpi.condition = this.benchmarkbtn == 'Update' ? this.objTranBenchmarkKPI.condition : 1;
    objBMKpi.tenantUno = this.tenantUno;

    this.restapiBM.addBenchMarkKPIEntry(objBMKpi)
      .subscribe(data => {

        if (data == "success") {
          if (flag == 'Update') {
            this.toaster.show('success', 'Success', 'BM Entry Data Updated.');
          } else {
            this.toaster.show('success', ' ', 'BM Entry Data saved.');
          }

          this.getBenchmarkKPIEntry(this.BMUno);
          this.clearEntryForm();
          this.benchmarkbtn = 'Add';
        }
        else {

          this.toaster.show('error', 'Error', 'Something went wrong');
          this.spinner.hide();
        }

      },
        (error) => {
          //Called when error

        }
      ).add(() => {
        //Called when operation is complete (both success and error)

      });
    return true;

  }

  DeleteBenchMarkEntry(deleteId: any) {
    
    let objBMKpi = new tranbenchmarkkpi();
    objBMKpi.id = deleteId;
    objBMKpi.userUno = this.login_UserID;

    this.restapiBM.deleteBenchMarkKPIEntry(objBMKpi)
      .subscribe(data => {
        
       if (data == "success") {
          this.toaster.show('success', 'Success', 'BM Entry Deleted.');
          this.getBenchmarkKPIEntry(this.BMUno);
        }
        else {
          //Swal.fire('Error', 'Something went wrong!', 'error')
          this.toaster.show('error', 'Error', 'Something went wrong');
         
        }

        this.spinner.hide();
      },
        (error) => {
          //Called when error
          this.spinner.hide();
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
        this.spinner.hide();
      });

  }


  onAddBenchMarkEntry() {
    
    this.isSubmitted = true;
    this.isAddentry = false;
    if (!this.checkAllValue()) {
      this.isAddentry = true;
      //  Swal.fire('Error', 'Please enter the required information.', 'error'); return;
      //}
      //else {
      this.isSubmitted = false;
      this.isDuplicateMsg = false;
      this.actualValue = (this.actualValue == '.') ? '0' : this.actualValue;

      if (this.benchmarkbtn == 'Add') {

        let data1 = this.objTranBenchmarkKPI;


        let source_text = this.source_data.filter((items: any) => items.id == this.sourceUno)[0].titleNameEn;
        let peer_text = this.peer_data.filter((items: any) => items.id == this.peerUno)[0].titleNameEn;
        let consideration_text = this.consideration_data.filter((items: any) => items.id == this.considerationUno)[0].titleNameEn;

        let objBenchmarkEntry = {


          kpiUno: this.selectedItemID,
          benchmarkYear: this.benchmarkYear,
          benchmarks: this.benchmarks,
          sourceUno: this.sourceUno,
          peerUno: this.peerUno,
          considerationUno: this.considerationUno,
          filter: this.filter,
          targetValue: this.targetValue,
          actualValue: this.actualValue,
          source_text: source_text,
          peer_text: peer_text,
          consideration_text: consideration_text
        }

        
        //Check Duplicate Entry
        if (!this.CheckDuplicateItem(objBenchmarkEntry)) {
          this.addBenchMarkEntry()
          this.clearEntryForm();
        }
        else {
          //Swal.fire('Error', 'Duplicate values not allowed.', 'error');
          this.toaster.show('warning', 'Warning', 'Duplicate values are not allowed.');
          return;
        }



      }
      else {
        let data1 = this.objTranBenchmarkKPI;
        let source_text = this.source_data.filter((items: any) => items.id == this.sourceUno)[0].titleNameEn;
        let peer_text = this.peer_data.filter((items: any) => items.id == this.peerUno)[0].titleNameEn;
        let consideration_text = this.consideration_data.filter((items: any) => items.id == this.considerationUno)[0].titleNameEn;
        let objBenchmarkEntry = {
          kpiUno: this.selectedItemID,
          benchmarkYear: this.benchmarkYear,
          benchmarks: this.benchmarks,
          sourceUno: this.sourceUno,
          peerUno: this.peerUno,
          considerationUno: this.considerationUno,
          filter: this.filter,
          targetValue: this.targetValue,
          actualValue: this.actualValue,
          source_text: source_text,
          peer_text: peer_text,
          consideration_text: consideration_text
        }

        
        //Check Duplicate Entry
        // this.multipleBemchMarkEntry.splice(this.selectedEditItemIndex, 1);
        if (!this.CheckDuplicateItem(objBenchmarkEntry)) {
          this.multipleBemchMarkEntry.push(objBenchmarkEntry);
          this.objTranBenchmarkKPI = new tranbenchmarkkpi();
          this.objTranBenchmarkKPI.condition = 1;
          this.addBenchMarkEntry()
        }
        else {
          //let source_text = this.source_data.filter((items: any) => items.id == this.sourceUno)[0].titleNameEn;
          //let peer_text = this.peer_data.filter((items: any) => items.id == this.peerUno)[0].titleNameEn;
          //let consideration_text = this.consideration_data.filter((items: any) => items.id == this.considerationUno)[0].titleNameEn;
          //let objBenchmarkEntry = {


          //  kpiUno: this.selectedItemID,
          //  benchmarkYear: this.selectedEditItem.benchmarkYear,
          //  benchmarks: this.selectedEditItem.benchmarks,
          //  sourceUno: this.selectedEditItem.sourceUno,
          //  peerUno: this.selectedEditItem.peerUno,
          //  considerationUno: this.selectedEditItem.considerationUno,
          //  filter: this.selectedEditItem.filter,
          //  targetValue: this.selectedEditItem.targetValue,
          //  actualValue: this.selectedEditItem.actualValue,
          //  source_text: source_text,
          //  peer_text: peer_text,
          //  consideration_text: consideration_text
          //}

          //this.multipleBemchMarkEntry.push(objBenchmarkEntry);
          ////Swal.fire('Error', 'Duplicate values not allowed.', 'error'); return;
          if (!this.isDuplicateMsg)
            this.toaster.show('warning', 'Warning', 'Duplicate values are not allowed.');
          this.objTranBenchmarkKPI.condition = 2;
          this.addBenchMarkEntry()
          this.clearEntryForm();
        }
        //this.objTranBenchmarkKPI = new tranbenchmarkkpi();
      }
    }
    return this.objTranBenchmarkKPI.condition;
  }

  checkAllValue() {
    let rtnValue = false;
    if (this.benchmarkYear == "" || this.sourceUno == "" || this.peerUno == "" || this.considerationUno == "" || this.filter == "" || this.targetValue == "" || this.actualValue == "") {
      rtnValue = true;
    }
    return rtnValue;
  }
  clearEntryForm() {

    this.benchmarkYear = "";
    this.benchmarks = "";
    this.sourceUno = "";
    this.peerUno = "";
    this.considerationUno = "";
    this.filter = "";
    this.targetValue = "";
    this.actualValue = "";
    this.benchmarkbtn = 'Add';
    this.isSubmitted = false;
  }

  CheckDuplicateItem(objBM: any) {
    this.isDuplicateMsg = false;
    if (this.multipleBemchMarkEntry != null && this.multipleBemchMarkEntry != undefined) {
      
      var rtnValue = false;
      //let listItems = this.multipleBemchMarkEntry;

      let enteredItem = objBM.benchmarkYear.toString() + objBM.sourceUno.toString() + objBM.peerUno.toString() + objBM.considerationUno.toString();
      for (var i = 0; i < this.multipleBemchMarkEntry.length; i++) {
        let item = this.multipleBemchMarkEntry[i];
        let existItem = item.benchmarkYear.toString() + item.sourceUno.toString() + item.peerUno.toString() + item.considerationUno.toString();

        if (enteredItem == existItem) {
          //To Update Exsiting Fields if any changes will be happened
          if (item.filter != objBM.filter || item.targetValue != objBM.targetValue || item.actualValue != objBM.actualValue) {
            this.multipleBemchMarkEntry[i].filter = objBM.filter;
            this.multipleBemchMarkEntry[i].targetValue = objBM.targetValue;
            this.multipleBemchMarkEntry[i].actualValue = objBM.actualValue;
            this.isDuplicateMsg = true;
          }

          // All fields are same
          if (enteredItem == existItem && item.filter == objBM.filter && item.targetValue && objBM.targetValue && item.actualValue == objBM.actualValue) {
            this.isDuplicateMsg = true;
          }

          rtnValue = true;

        }



      }

      //listItems.forEach((item) => {
      //  let existItem = item.benchmarkYear + item.sourceUno + item.peerUno + item.considerationUno;
      //  //if ((objBM.benchmarkYear == item.benchmarkYear) || (objBM.benchmarks.trim().toLowerCase() == item.benchmarks.trim().toLowerCase()) || (objBM.sourceUno == item.sourceUno) || (objBM.peerUno == item.peerUno) || (objBM.considerationUno == item.considerationUno))
      //  if (enteredItem == existItem)
      //  {

      //    rtnValue = true;
      //  }

      //});

      return rtnValue;
    }
  }
  onRemoveItem(idx) {
    

    if (this.multipleBemchMarkEntry.length > 1) {
      this.deleteId = idx;
      Swal.fire({
        title: 'Delete',
        text: 'Please confirm to delete the record',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Ok',
        cancelButtonText: 'Cancel'
      }).then((result) => {
        if (result.value) {
          this.DeleteBenchMarkEntry(this.deleteId);
        } else if (result.dismiss === Swal.DismissReason.cancel) {

        }
      })
    }
    else {
      this.toaster.show('warning', 'Warning', 'At least one benchmark entry is required.');
      return false;
    }

    return false;
  }
  onEditItem(idx) {
    

    //this.objTranBenchmarkKPI = new tranbenchmarkkpi();

    //let item = this.multipleBemchMarkEntry;
    //for (var i = 0; i < this.multipleBemchMarkEntry.length; i++) {
    //  if (i == idx) {
    //    this.objTranBenchmarkKPI = item[i];
    //    break;
    //  }
    //}

    //this.objTranBenchmarkKPI = this.multipleBemchMarkEntry[idx];
    try {
      this.selectedEditItem = this.multipleBemchMarkEntry[idx];
      this.benchmarkYear = this.selectedEditItem.benchmarkYear;
      this.benchmarks = "N/A";//this.selectedEditItem.benchmarks;
      this.sourceUno = this.selectedEditItem.sourceUno;
      this.peerUno = this.selectedEditItem.peerUno;
      this.considerationUno = this.selectedEditItem.considerationUno;
      this.filter = this.selectedEditItem.filter;
      this.targetValue = this.selectedEditItem.targetValue;
      this.actualValue = this.selectedEditItem.actualValue;
      this.id = this.selectedEditItem.id;
      this.selectedEditItemIndex = idx;
      this.benchmarkbtn = 'Update';
      return false;
    }
    catch(e) {
      console.log(e);
    }
  }
  onSaveBenchMarkEntry(val1, type) {
    //if (this.isAddentry) {

    if (this.multipleBemchMarkEntry.length > 0) {
      this.AddEditBenchMarkMultiEntry();
    }
    else {
      //Swal.fire('Error', 'Add alteast one entry and save', 'error');
      this.toaster.show('warning', 'Warning', 'At least one benchmark entry is required.');
      return false;
    }

    //}
    //else {
    //  this.toaster.show('warning', 'Warning', 'At least one benchmark entry is required.');
    //}
    return false;
  }

  AddEditBenchMarkMultiEntry() {
    
    this.clearEntryForm();
    this.benchmarkbtn = 'Add';
    let objKPI = new benchmarkkpientry();
    objKPI.userUno = this.login_UserID;
    objKPI.tenantUno = this.tenantUno;
    //XML Value For KPIBenchMark Entry

    let entryItems = this.multipleBemchMarkEntry;
    
    if (entryItems.length > 0) {
      objKPI.benchMarkKPIUno = entryItems[0].kpiUno;
      let strXmlValue = '<roots>';
      for (var i = 0; i < entryItems.length; i++) {

        entryItems[i].actualValue = (entryItems[i].actualValue == '.') ? '0' : entryItems[i].actualValue;

        strXmlValue += "<root>";
        strXmlValue += "<BenchMarkYear>" + entryItems[i].benchmarkYear + "</BenchMarkYear>";
        strXmlValue += "<SourceUno>" + entryItems[i].sourceUno + "</SourceUno>";
        strXmlValue += "<PeerUno>" + entryItems[i].peerUno + "</PeerUno>";
        strXmlValue += "<ConsiderationUno>" + entryItems[i].considerationUno + "</ConsiderationUno>";
        strXmlValue += "<Filter>" + entryItems[i].filter + "</Filter>";
        strXmlValue += "<BenchMark>" + entryItems[i].benchmarks + "</BenchMark>";
        strXmlValue += "<TargetValue>" + entryItems[i].targetValue + "</TargetValue>";
        strXmlValue += "<ActualValue>" + entryItems[i].actualValue + "</ActualValue>";
        strXmlValue += "</root>";
      }
      strXmlValue += '</roots>';
      
      objKPI.xmlValue = strXmlValue;
    }
    else {
      objKPI.xmlValue = '';
    }


    this.modalRef.hide();
    
    this.restapiBM.addEditBenchMarkKPIEntry(objKPI)
      .subscribe(data => {
        
        if (data != null && data != undefined && data != '') {
          // Swal.fire('Error', 'Something went wrong', 'error');
          this.toaster.show('error', 'Error', 'Something went wrong');
          this.spinner.hide();
        }
        else {
          this.modalRef.hide();
          //Swal.fire({
          //  type: 'success',
          //  title: 'Bench Mark Entry saved.',
          //  showConfirmButton: false,
          //  timer: 1500
          //})
          this.toaster.show('success', 'Success', 'Benchmark entry saved.');
          setTimeout(() => {
            this.spinner.hide();
            this.multipleBemchMarkEntry = [];
            this.loadBenchMarkKPI();
          }, 900);

        }



      },
        (error) => {
          //Called when error
          this.spinner.hide();
          this.multipleBemchMarkEntry = [];
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
        //this.spinner.hide();
      });
  }

  AddEditBenchMarkEntry(data1: any, type: any) {
    
    let objKPI = new tranbenchmarkkpi();
    //objKPI = data1
    //objKPI.dataOwnerUno = (objKPI.dataOwnerUno) ? objKPI.dataOwnerUno.toString() : '';
    //objKPI.level1ApproverUno = (objKPI.level1ApproverUno) ? objKPI.level1ApproverUno.toString() : '';
    //objKPI.level2ApproverUno = (objKPI.level2ApproverUno) ? objKPI.level2ApproverUno.toString() : '';
    //objKPI.level3ApproverUno = (objKPI.level3ApproverUno) ? objKPI.level3ApproverUno.toString() : '';
    //objKPI.actionType = this.pageAction;
    //objKPI.kpiUno = (this.pageAction == "add") ? 0 : this.utilityService.isNumericNull(data1.kpiUno);

    //objKPI.slaUno = 1;

    //objKPI.userUno = this.login_UserID;
    //objKPI.condition = (this.pageAction == "add") ? 0 : 1;
    //objKPI.tenantUno = 1;
    //objKPI.benchMarked = this.isBenchMark;
    objKPI.trnBenchmarkUno = data1.trnBenchmarkUno;
    objKPI.kpiUno = this.selectedItemID;
    objKPI.benchmarkYear = data1.benchmarkYear;
    objKPI.benchmarks = data1.benchmarks;
    objKPI.sourceUno = data1.sourceUno;
    objKPI.peerUno = data1.peerUno;
    objKPI.considerationUno = data1.considerationUno;
    objKPI.filter = data1.filter;
    objKPI.constraints = data1.constraints;
    objKPI.formula = '';
    objKPI.userUno = this.login_UserID;
    objKPI.condition = (!this.isTranData) ? 0 : 1;
    objKPI.tenantUno = this.tenantUno;
    objKPI.isRelease = (type == "submit") ? true : false;
    let sourcedata = this.source_data.filter((items: any) => items.id == data1.sourceUno)[0];
    let peerdata = this.peer_data.filter((items: any) => items.id == data1.peerUno)[0];

    objKPI.sourceTypeUno = sourcedata.sourceTypeUno;
    objKPI.peerTypeUno = sourcedata.peerTypeUno;
    objKPI.continentUno = peerdata.continentUno;
    objKPI.countryUno = peerdata.countryUno;
    objKPI.regionUno = peerdata.regionUno;

    
    this.restapiBM.addEditTranBenchMarkKPI(objKPI)
      .subscribe(data => {

        if (data != null && data != undefined && data != '') {
          //Swal.fire('Error', 'Something went wrong', 'error');
          this.toaster.show('error', 'Error', 'Something went wrong');
          this.spinner.hide();
        }
        else {
          //Swal.fire({
          //  type: 'success',
          //  title: (type == 'submit') ?'Bench Mark Entry submitted.':'Bench Mark Entry saved.',
          //  showConfirmButton: false,
          //  timer: 1500
          //})

          this.toaster.show('success', 'Success', (type == 'submit') ? 'Benchmark entry submitted.' : 'Benchmark entry saved.');
          this.modalRef.hide();
          setTimeout(() => { this.spinner.hide(); this.loadBenchMarkKPI(); }, 900);

        }



      },
        (error) => {
          //Called when error
          this.spinner.hide();
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
        //this.spinner.hide();
      });
  }

  isNumberKey(txt, evt) {
    
    this.isSubmitted = false;

    //RemoveSpecial Charecter
    txt.actualValue = (txt.actualValue.length > 0) ? txt.actualValue.replace(/[^0-9.]/g, "") : '';

    //Remove morethen one dot value
    if (txt.actualValue.replace(/[^.]/g, "").length > 1) {
      this.actualValue = txt.actualValue.substring(0, txt.actualValue.length - 1);
    }

    //var charCode = (evt.which) ? evt.which : evt.keyCode;
    //if (charCode == 46 || charCode == 190) {
    //  //Check if the text already contains the . character
    //  if (txt.actualValue.indexOf('.') === -1) {
    //    return true;
    //  } else {
    //    this.actualValue = txt.actualValue.substring(0, txt.actualValue.length - 1);
    //    return false;
    //  }
    //} else {
    //  if (charCode > 31 && (charCode < 48 || charCode > 57)) {
    //    this.actualValue = txt.actualValue.substring(0, txt.actualValue.length - 1);
    //    return false;
    //  }

    //}
    //return true;

    return false;
  }

  isYear1NumberKey(txt, evt) {
    
    this.isSubmitted = false;

    //RemoveSpecial Charecter

    txt.year1Value = (txt.year1Value.length > 0) ? txt.year1Value.replace(/[^0-9.]/g, "") : '';

    //Remove morethen one dot value
    if (txt.year1Value.replace(/[^.]/g, "").length > 1) {
      this.year1Value = txt.actualValue.substring(0, txt.actualValue.length - 1);
    }



    return false;
  }
  isYear2NumberKey(txt, evt) {
    
    this.isSubmitted = false;

    //RemoveSpecial Charecter

    txt.year2Value = (txt.year2Value.length > 0) ? txt.year2Value.replace(/[^0-9.]/g, "") : '';

    //Remove morethen one dot value
    if (txt.year2Value.replace(/[^.]/g, "").length > 1) {
      this.year2Value = txt.actualValue.substring(0, txt.actualValue.length - 1);
    }



    return false;
  }

  isYear3NumberKey(txt, evt) {
    
    this.isSubmitted = false;

    //RemoveSpecial Charecter

    txt.year3Value = (txt.year3Value.length > 0) ? txt.year3Value.replace(/[^0-9.]/g, "") : '';

    //Remove morethen one dot value
    if (txt.year3Value.replace(/[^.]/g, "").length > 1) {
      this.year3Value = txt.actualValue.substring(0, txt.actualValue.length - 1);
    }



    return false;
  }
  onchangeDropDown(e) {
    this.isSubmitted = false;
  }
  onkeypress(e) {
    this.isSubmitted = false;
  }

  loadYear() {

    let inpValue = new year();
    inpValue.languageUno = 1033;
    inpValue.itemUno = 0;
    inpValue.condition = 0;
    inpValue.tenantUno = this.tenantUno;
    inpValue.userUno = this.login_UserID;
    
    this.restSLAKPIApi.getYearMaster(inpValue)
      .subscribe(data => {
        
        this.yearData = data;

      },
        (error) => {
          //Called when error

        }
      ).add(() => {
        //Called when operation is complete (both success and error)

      });
  }



  getKPIBenchmarkEntry_Export(itemUno: any) {
    
    let inpValue = new tranbenchmarkkpi();
    inpValue.languageUno = 1033;
    inpValue.itemUno = itemUno;
    inpValue.condition = 2;
    inpValue.userUno = this.login_UserID;
    inpValue.tenantUno = this.tenantUno;
    this.BMUno = itemUno
    this.restapiBM.getKPIBenchmarkEntry_Export(inpValue)
      .subscribe(data => {
        
        if (data != null && data != undefined) {
          this.benchMarkEntryExportList = data;
        }
        else {
          this.benchMarkEntryExportList = [];
        }
      },
        (error) => {
          this.benchMarkEntryExportList = [];
          //Called when error
        }
      ).add(() => {

        //Called when operation is complete (both success and error)
      });
  }



  exportToExcel_BenchmarkEntry() {

    if (this.benchMarkEntryExportList.length == 0 || this.benchMarkEntryExportList == null || this.benchMarkEntryExportList == undefined) {
      this.getKPIBenchmarkEntry_Export(0);
    }
    let items = [];
    const wb = { SheetNames: [], Sheets: {} };
    let filename = 'master.xlsx';


    for (var i = 0; i < this.benchMarkEntryExportList.length; i++) {
      items.push({
        ID: i + 1,
        Division: this.benchMarkEntryExportList[i].divisionName,
        KPINameEn: this.benchMarkEntryExportList[i].kpiNameEn,
        Year: this.benchMarkEntryExportList[i].benchmarkYear,        
        Source: this.benchMarkEntryExportList[i].sourceName,
        Peers: this.benchMarkEntryExportList[i].peerName,
        Considered_benchmarks: this.benchMarkEntryExportList[i].considerationName,
        Filter: this.benchMarkEntryExportList[i].filter,
        Constraints: this.benchMarkEntryExportList[i].targetValue,
        Actual: this.benchMarkEntryExportList[i].actualValue
       
      });
    }
    filename = 'BenchmarkKpi.xlsx'
    var ws = XLSX.utils.json_to_sheet(items);
    wb.SheetNames.push("BenchmarkKpi"); wb.Sheets["BenchmarkKpi"] = ws;

    const excelBuffer: any = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
    const dataVal: Blob = new Blob([excelBuffer], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8'
    });
    if (window.navigator.msSaveOrOpenBlob) //IE & Edge
    {
      //msSaveBlob only available for IE & Edge
      window.navigator.msSaveBlob(dataVal, filename);
    }
    else //Chrome & FF
    {
      var url = window.URL.createObjectURL(dataVal);
      var a = document.createElement('a');
      document.body.appendChild(a);
      a.setAttribute('style', 'display: none');
      a.href = url;
      a.download = filename;
      a.click();
      window.URL.revokeObjectURL(url);
      a.remove(); // remove the element
    }



  }

  removeHTMLTags(value) {
    if ((value === null) || (value === ''))
      return value = '';
    else
      return value.replace(/(<([^>]+)>)/ig, '');
  }


  getGeographicArea() {

    let inpValue = new geographicArea();
    inpValue.userUno = this.login_UserID;
    inpValue.languageUno = 1033;
    inpValue.itemUno = 0;
    inpValue.condition = 5;
    inpValue.tenantUno = this.tenantUno;
    this.restapiBM.getGeographicArea(inpValue)
      .subscribe(data => {
        
        
        let rtnData:any = [];
        rtnData = data;
        let items = [];
        for (var i = 0; i < rtnData.length; i++) {
          items.push({
            id: rtnData[i].areaUno,
            text: rtnData[i].areaNameEn,
            checked:false
          });
        }
        this.geographicAreaList = items;
      },
        (error) => {
          //Called when error
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
      });
  }
  selectCheckBoxMultiple(ev: any, item: any) {
    

    if (ev.currentTarget.checked) {
      item.checked = true;
      this.selectedAreaItems.push(item);      
    }
    else {
      //remove from list
      this.selectedAreaItems = this.selectedAreaItems.filter((x) => x.id != item.id);
    }
  }

  addImportTemplate() {
    
    this.uploadedFiles = '';
    this.data = '';
    this.importRef = this.modalService.show(
      this.importtemplate,
      Object.assign({}, {
        class: 'gray modal-lg',
        backdrop: true,
        keyboard: true,
        focus: true,
        show: false,
        ignoreBackdropClick: true,
        animated: true
      })
    );

  }

  importToExcel_BenchmarkEntry() {
    

    const file = this.uploadedFiles[0];

    if (this.uploadedFiles.length == 0) {
      this.toaster.show('error', 'Error', 'Choose any one files is allowed.');
      this.spinner.hide();
      return
    }
    else if (this.uploadedFiles.length > 1) {
      this.toaster.show('error', 'Error', 'Only one files is allowed.');
      this.spinner.hide();
      return
    }


    const extension = file.name.split('.').pop();
    if (extension !== 'xlsx' && extension !== 'xls') {

      this.toaster.show('error', 'Error', 'Only .xlsx files allowed.');
      this.spinner.hide();
      return

    }



    /* wire up file reader */



    const reader: FileReader = new FileReader();
    reader.onload = (e: any) => {
      /* read workbook */
      const bstr: string = e.target.result;
      const wb: XLSX.WorkBook = XLSX.read(bstr, { type: 'binary' });

      const wsname: string = wb.SheetNames[0];
      const ws: XLSX.WorkSheet = wb.Sheets[wsname];


      /* save data */
      this.data = (XLSX.utils.sheet_to_json(ws, { header: 1 }));
      this.data1 = this.data;



      let importArrayData = [];
      let importArrayData2 = [];
      const expectedColumns: string[] = ['Year', 'Source', 'Peers', 'Considered_benchmarks', 'Filter', 'Constraints', 'Actual'];

      const headers: string[] = this.data[0];

      if (JSON.stringify(expectedColumns) === JSON.stringify(headers)) {
        //  this.toaster.show('error', 'Error', 'That files columns are  equal');

        //data = importArrayData
        for (let i = 1; i < this.data1.length; i++) {
          let Considered_benchmarks:any;
          let peerName: any;
          let source: any;
          let sourceName: any;
          let Considered_benchmarksName: any;
          if (this.data1[i][2] != '' && this.data1[i][2] != undefined && this.data1[i][2] != null) {
            let peer = this.peer_data.filter((a: any) => a.titleNameEn.toLowerCase() == this.data1[i][2].toLowerCase());
            this.peer = peer.length>0 ? peer[0].id : 0;
            peerName = peer.length > 0 ? peer[0].titleNameEn : '-';
          }
          else {
            peerName = '-';
            this.peer = 0;
          }
         
          this.datas = " NRDC:\r\nBenchmarking Air Emissions of the 100 Largest Electric Power Producers in the U.S.";

          if (this.data1[i][1] == this.datas) {
            this.data1[i][1] = " NRDC:\nBenchmarking Air Emissions of the 100 Largest Electric Power Producers in the U.S.";
          }

          if (this.data1[i][1] != '' && this.data1[i][1] != undefined && this.data1[i][1] != null) {
            source = this.source_data.filter((a: any) => a.titleNameEn.toLowerCase() == this.data1[i][1].toLowerCase());
            this.source = source.length > 0 ? source[0].id : 0;
            sourceName = source.length > 0 ? source[0].titleNameEn : '-';
          }
          else {
            sourceName = '-';
            this.source = 0;
          }
          if (this.data1[i][3] != '' && this.data1[i][3] != undefined && this.data1[i][3] != null) {
            Considered_benchmarks = this.consideration_data.filter((a: any) => a.titleNameEn.toLowerCase() == this.data1[i][3].toLowerCase());
            this.Considered_benchmarks = Considered_benchmarks.length > 0 ? Considered_benchmarks[0].id : 15;
            Considered_benchmarksName = Considered_benchmarks.length > 0 ? Considered_benchmarks[0].titleNameEn : '';
          }
          else {
            Considered_benchmarksName = '';
            this.Considered_benchmarks = 15;
          }
          let value = {
            Year: (this.data1[i][0] != '' && this.data1[i][0] != undefined && this.data1[i][0] != null) ? this.data1[i][0] : '',
            Source: this.source,
            Peers: this.peer,
            Considered_benchmarks: this.Considered_benchmarks,
            Filter: (this.data1[i][4] != '' && this.data1[i][4] != undefined && this.data1[i][4] != null) ? this.data1[i][4] : '',
            Constraints: (this.data1[i][5] != '' && this.data1[i][5] != undefined && this.data1[i][5] != null) ? this.data1[i][5] : '', 
            Actual: (this.data1[i][6] != '' && this.data1[i][6] != undefined && this.data1[i][6] != null) ? this.data1[i][6] : 0,
            BenchMarkKPIUno: this.BMUno,

          }
          let value2 = {
            Year: (this.data1[i][0] != '' && this.data1[i][0] != undefined && this.data1[i][0] != null) ? this.data1[i][0] : '',
            Source: sourceName,
            Peers: peerName,
            Considered_benchmarks: Considered_benchmarksName,
            Filter: (this.data1[i][4] != '' && this.data1[i][4] != undefined && this.data1[i][4] != null) ? this.data1[i][4] : '',
            Constraints: (this.data1[i][5] != '' && this.data1[i][5] != undefined && this.data1[i][5] != null) ? this.data1[i][5] : '', 
            Actual: (this.data1[i][6] != '' && this.data1[i][6] != undefined && this.data1[i][6] != null) ? this.data1[i][6] : 0,
            BenchMarkKPIUno: this.BMUno,

          }

          importArrayData.push(value);
          importArrayData2.push(value2)

        }
        this.importDataList_old = importArrayData;
        let emptyArray = [];
        let allItemArray = [];
        for (let i = 0; i < importArrayData2.length; i++) {

          
          if (importArrayData2[i].Source == "-" || importArrayData2[i].Peers == "-" || importArrayData2[i].Considered_benchmarks == "-") {
            
            let arrBMEntry = {
              Year: importArrayData2[i].Year,
              Source: importArrayData2[i].Source,
              Peers: importArrayData2[i].Peers,
              Considered_benchmarks: importArrayData2[i].Considered_benchmarks,
              Filter: importArrayData2[i].Filter,
              Constraints: importArrayData2[i].Constraints,
              Actual: importArrayData2[i].Actual,
              BenchMarkKPIUno: this.BMUno,
              IsAction:true

            }
            emptyArray.push(arrBMEntry);
            }
          else {
            let arrBMEntry = {
              Year: importArrayData2[i].Year,
              Source: importArrayData2[i].Source,
              Peers: importArrayData2[i].Peers,
              Considered_benchmarks: importArrayData2[i].Considered_benchmarks,
              Filter: importArrayData2[i].Filter,
              Constraints: importArrayData2[i].Constraints,
              Actual: importArrayData2[i].Actual,
              BenchMarkKPIUno: this.BMUno,
              IsAction: false

            }
            allItemArray.push(arrBMEntry);
            }
          
         
        }
        let concatArray = emptyArray.concat(allItemArray);
        this.importDataList = concatArray;
        //this.addImportData(importArrayData)

      }
      else {
        this.toaster.show('error', 'Error', 'That files columns are not matched');
        this.spinner.hide();
        return
      }

    };
    reader.readAsBinaryString(this.uploadedFiles[0]);

  }
  onImportDataRemoveItem(idx) {
    
    //let item = this.multipleBemchMarkEntry;
    //for (var i = 0; i < this.multipleBemchMarkEntry.length; i++) {
    //  if (i == idx) {
    //    item = this.multipleBemchMarkEntry.splice(i, 1);
    //    //this.multipleBemchMarkEntry = [];
    //    //this.multipleBemchMarkEntry = item;
    //    break;
    //  }
    //}
    if (this.importDataList.length > 1) {
      this.importDataList.splice(idx, 1);
      this.importDataList_old.splice(idx, 1);
    }
    else {
      
      return false;
    }

    return false;
  }
  changeEvent(event: any) {
    
  }
  addImportData() {
    

    let objImport = new importtranbenchmarkkpi();
    objImport.importData = this.importDataList_old;
    objImport.languageUno = 1033;
    objImport.condition = 0;
    objImport.tenantUno = this.tenantUno;
    objImport.userUno = this.login_UserID;
  
    this.restapiBM.addImportTranBenchMarkKPI(objImport)
      .subscribe((data) => {

        if (data != null && data != undefined && data != 'failure') {
          this.toaster.show('success', 'Success', 'Import Data saved.');
          this.importRef.hide();
          // this.entryTemplate()
          this.getBenchmarkKPIEntry(this.BMUno);
          this.spinner.hide();
        }
        else {
          this.toaster.show('error', 'Error', 'Import Data not saved.');
        }
      },
        (error) => {
          //Called when error
          this.spinner.hide();
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
        //this.spinner.hide();
      });
  }

  entryTemplate() {
    this.modalRef = this.modalService.show(
      this.entrytemplate,
      Object.assign({}, {
        class: 'gray modal-lg',
        backdrop: true,
        keyboard: true,
        focus: true,
        show: false,
        ignoreBackdropClick: true,
        animated: true
      })
    );

  }

  AttachmentDownload() {
    
    let fileName = "Benchmark Entry Template";
    let inpValue = new filecontent();
    inpValue.itemUNo = "0";
    inpValue.userUno = this.login_UserID;
    this.restapiBM.BMEntryTemplateDownload(inpValue).subscribe(
      (data: any) => {


        if (data != null) {

          if (window.navigator.msSaveOrOpenBlob) //IE & Edge
          {
            //msSaveBlob only available for IE & Edge
            window.navigator.msSaveBlob(data.filedata, fileName);
          }
          else //Chrome & FF
          {
            var url = window.URL.createObjectURL(data);
            var a = document.createElement('a');
            document.body.appendChild(a);
            a.setAttribute('style', 'display: none');
            a.href = url;
            a.download = fileName;
            a.click();
            window.URL.revokeObjectURL(url);
            a.remove(); // remove the element
          }

        }
        else {
          /// this._toastr.error(this._translateService.instant('errorupdate'), '', { toastLife: 1500 });
        }
      },
      error => {

        /// this._toastr.error(this._translateService.instant('errorupdate'), '', { toastLife: 1500 });
      },
      () => {
        // 'onCompleted' callback.


      }
    );

  }

  searchSearchBenchmarkList() {
    
    if (this.searchBecnhmarkListText != "") {
      this.multipleBemchMarkEntry = this.benchMarkList.filter(a =>
        a.benchmarkYear && a.benchmarkYear.toString().toLowerCase().includes(this.searchBecnhmarkListText.toLowerCase())
        || (a.benchmarks && a.benchmarks.toLowerCase().includes(this.searchBecnhmarkListText.toLowerCase()))
        || (a.source_text && a.source_text.toLowerCase().includes(this.searchBecnhmarkListText.toLowerCase()))
        || (a.peer_text && a.peer_text.toLowerCase().includes(this.searchBecnhmarkListText.toLowerCase()))
        || (a.consideration_text && a.consideration_text.toLowerCase().includes(this.searchBecnhmarkListText.toLowerCase()))
        || (a.filter && a.filter.toLowerCase().includes(this.searchBecnhmarkListText.toLowerCase()))
        || (a.targetValue && a.targetValue.toLowerCase().includes(this.searchBecnhmarkListText.toLowerCase()))
        || (a.actualValue && a.actualValue.toString().toLowerCase().includes(this.searchBecnhmarkListText.toLowerCase()))
      );
    }
    else
      this.multipleBemchMarkEntry = this.benchMarkList;
  }

}
